<template>
    <div class="form-group">
        <div v-if="infoText" class="d-flex align-items-center">
            <label v-if="label" class="mr-1">{{ label }}</label>
            <InfoToolTip v-if="infoText" :info="infoText" class="pb-1" />
        </div>

        <label v-if="label && !infoText">
            {{ label }} 
            <span v-if="ejemplo" style="color: inherit; font-weight: normal;">{{ ejemplo }}</span>
        </label>

        <ValidationProvider :name="name" :rules="rules" v-bind="providerProps" v-slot="{ errors }">
            <div class="position-relative">
                <input 
                    v-model="hidden_value" 
                    @input="handleInput" 
                    @change="handleChange" 
                    :placeholder="placeholder || label"
                    :maxlength="maxlength"
                    v-bind="$attrs" 
                    class="form-control w-100" 
                    :class="{'is-invalid': errors[0], 'dni-front': front, 'pr-2': quitar_pr, 'pr-5': !quitar_pr}"
                />
                <span v-if="maxlength" class="char-counter">
                    {{ hidden_value.length }}/{{ maxlength }}
                </span>
            </div>
            <span v-if="errors[0]" :class="{ 'dni-front': front }" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
            <span v-if="apiValidationError" :class="{ 'dni-front': front }" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ Array.isArray(apiValidationError) ? apiValidationError.join(', ') : apiValidationError }}</b></span>
        </ValidationProvider>
    </div>
</template>

<script>
    import InfoToolTip from '@/components/common/InfoToolTip';

    export default {
        props: ["label", "rules", "name", "value","apiValidationError", "placeholder", "infoText", "front", "vid", "maxlength", "ejemplo", "quitar_pr"],
        inheritAttrs: false,
        data() {
            return {
                hidden_value: this.value || ''
            }
        },
        methods: {
            handleInput(e) {
                this.$emit('input', e.target.value)
            },
            handleChange(e) {
                this.$emit('change', e.target.value)
            }
        },
        computed: {
            providerProps() {
                return this.vid ? { vid: this.vid } : {};
            }
        },
        components: {
            InfoToolTip
        }
    }
    </script>

    <style scoped>
    .dni-front {
        width: 80%;
    }

    .position-relative {
        position: relative;
    }

    .char-counter {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 12px;
        color: #AAAAAA;
        font-weight: bold;
        background: white;
        padding: 2px 5px;
        border-radius: 4px;
    }
</style>